const _categories = {
  pecas: 1,
  ferramentas: 2,
  produtos: null,
};

export const productFilter = {
  computed: {
    query() {
      return this.$route.query;
    },
    search: {
      get() {
        return this.query.s || "";
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.s = v;
        else delete query.s;

        delete query.p;

        const path = ["/pecas", "/ferramentas", "/produtos"].includes(
          this.$route.path
        )
          ? this.$route.path
          : "/produtos";

        this.$router.push({ path, query });
      },
    },
    categoryId() {
      return _categories[this.$route.path.replace("/", "")] || null;
    },
    subcategoriesSelecteds: {
      get() {
        return this.query.c
          ? this.query.c.split(",").map((v) => parseInt(v))
          : [];
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.c = v.join(",");
        else delete query.c;

        this.$router.push({ query });
      },
    },
  },
};
